// extracted by mini-css-extract-plugin
module.exports = {"dsWrapper":"App__dsWrapper--1kexh","app":"App__app--2rxP8"};